import './style.css'
import { initNavigation } from './js/navigation.js'
import { initAnimations } from './js/animations.js'
import { initContactForm } from './js/contact.js'

// Initialize the application
document.addEventListener('DOMContentLoaded', () => {
    console.log('DataBrain website loaded')
    
    // Initialize modules
    initNavigation()
    initAnimations()
    initContactForm()
})